export default (state = false, action) => {
  let { type } = action
  switch (type) {
    case 'BLOCK_FEATURES':
      return true
    case 'UNBLOCK_FEATURES':
      return false
    case 'LOGOUT':
      return false
    default:
      return state
  }
}